/**
 * @file セレクトでの項目表示／非表示
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ToggleSelect
 * @classdesc セレクトでの項目表示／非表示
 */
export default class ToggleSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-select-toggle=true]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._value = $e.attr('data-value');
		this._$target = $($e.attr('data-target'));
		this._$e.on('change', () => this.onChange());
		this.onChange();
	};


	/**
	 * Changeのコールバック
	 *
	 * @memberof ToggleSelect
	 * @return {undefined}
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		if(this._$e.val() === this._value){
			this._$target.show().find('.validate').removeClass('ignore-validate');
		}else{
			Common.addIgnoreValidate(this._$target);
		}
	}
}
